import { render } from "./ButtonGrid.vue?vue&type=template&id=6853ebdc"
import script from "./ButtonGrid.vue?vue&type=script&lang=js"
export * from "./ButtonGrid.vue?vue&type=script&lang=js"

import "./ButtonGrid.vue?vue&type=style&index=0&id=6853ebdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__